import Actions from "./dashboardConstants";
import produce from "immer";

const initialState = {
  unbatchedDocsSummary: { loading: false, data: [], operationResult: null },
  inventoryAlertSummary: { loading: false, data: [], fetched: false, operationResult: null },
  production: {
    agencySummary: { loading: false, data: [], operationResult: null },
    txnDateSummary: { loading: false, data: [], operationResult: null },
  },
};

export const reducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case Actions.GET_UNBATCHED_DOCS_SUMMARY:
        draft.unbatchedDocsSummary.loading = true;
        return draft;
      case Actions.GET_UNBATCHED_DOCS_SUMMARY_SUCCEEDED:
        draft.unbatchedDocsSummary.data = action.payload.Data;
        draft.unbatchedDocsSummary.operationResult = action.payload.Operation;
        draft.unbatchedDocsSummary.loading = false;
        return draft;
      case Actions.GET_INVENTORY_ALERT_SUMMARY:
        draft.inventoryAlertSummary.loading = true;
        draft.inventoryAlertSummary.data = [];
        draft.inventoryAlertSummary.fetched = false;
        return draft;
      case Actions.GET_INVENTORY_ALERT_SUMMARY_SUCCEEDED:
        draft.inventoryAlertSummary.data = action.payload.Data;
        draft.inventoryAlertSummary.operationResult = action.payload.Operation;
        draft.inventoryAlertSummary.loading = false;
        draft.inventoryAlertSummary.fetched = true;
        return draft;
      default:
        return state;
    }
  });
};
